
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getVideogames } from "../../redux/actions";
import './searchBar.css'
export default function SearchBar() {
  const dispatch= useDispatch()
  const [name,setName] = useState("");

  
  function handleInputchange(e){
    e.preventDefault()
    setName(e.target.value)
  }
  function handleSubmit(e){
    e.preventDefault()
    dispatch(getVideogames(name))
    setName('')
    // return(
    //   dispatch(getVideogames())
    // )
  }


 
  return (
    <div class="container h-100">
      <div class="d-flex justify-content-center h-100">
       <form class="searchbar">
      <input
        type="text"
        placeholder="Search Videogame..."
        value={name}
        onChange={e =>
           handleInputchange(e)
          }
          class='search_input'
      />
      <button type="submit"
      onClick={(e)=>handleSubmit(e)}
  class="search_icon"
        > <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-search-heart-fill" viewBox="0 0 16 16">
        <path d="M6.5 13a6.474 6.474 0 0 0 3.845-1.258h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.008 1.008 0 0 0-.115-.1A6.471 6.471 0 0 0 13 6.5 6.502 6.502 0 0 0 6.5 0a6.5 6.5 0 1 0 0 13Zm0-8.518c1.664-1.673 5.825 1.254 0 5.018-5.825-3.764-1.664-6.69 0-5.018Z"/>
      </svg></button>
    </form>
    </div>
    </div>
   
  );
}
